import type { SVGProps } from 'react';
const SvgCampfire = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.905 4.715s-.863-1.043-1.367-1.445c-.195-.156-.406-.262-.663-.27a1.01 1.01 0 0 0-.715.266c-.824.75-1.757 1.734-2.491 2.847-.73 1.106-1.293 2.383-1.293 3.71 0 3.145 2.476 5.676 5.623 5.676 3.116 0 5.623-2.527 5.623-5.675 0-1.067-.386-2.164-.921-3.129a10.4 10.4 0 0 0-1.933-2.507 1.02 1.02 0 0 0-.7-.278.96.96 0 0 0-.733.317zm1.425 6.811a2.273 2.273 0 1 1-4.545 0c0-1.296 1.316-2.593 1.945-3.14a.5.5 0 0 1 .656 0c.629.547 1.944 1.844 1.944 3.14M4.272 14.311a.938.938 0 0 0-.668 1.754l6.752 2.558-6.748 2.562a.939.939 0 0 0 .668 1.754l8.723-3.312 8.728 3.308a.937.937 0 1 0 .668-1.754l-6.752-2.558 6.747-2.562a.939.939 0 0 0-.667-1.754l-8.724 3.312z"
    />
  </svg>
);
export default SvgCampfire;
